import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Pagination, Autoplay } from "swiper/modules"

export default class extends Controller {
  static values = {
    navigation: { type: Boolean, default: false },
    pagination: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: false },
    loop: { type: Boolean, default: true }
  }

  connect() {
    this.initializeSwiper()
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  }

  initializeSwiper() {
    const modules = []
    const config = {
      loop: this.loopValue,
      spaceBetween: 0,
      slidesPerView: 1
    }

    if (this.navigationValue) {
      modules.push(Navigation)
      config.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    }

    if (this.paginationValue) {
      modules.push(Pagination)
      config.pagination = {
        el: ".swiper-pagination",
        clickable: true
      }
    }

    if (this.autoplayValue) {
      modules.push(Autoplay)
      config.autoplay = {
        delay: 3000,
        disableOnInteraction: false
      }
    }

    config.modules = modules

    this.swiper = new Swiper(this.element, config)
  }
}
